<p-tabView>
        <p-tabPanel header="Usuarios">
            <div class="flex justify-content-end">
                <p-button label="Añadir usuario" icon="pi pi-plus" styleClass=""
                    (click)="editUserGroupPermission('USER', null)"></p-button>
            </div>

            <p-table styleClass="m-1 mt-4" #grid [value]="usersPermissions" [loading]="loading" [paginator]="false"                                
                 [scrollable]="true" scrollHeight="flex"
                paginatorDropdownAppendTo="body">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th pSortableColumn="user.name">Usuario <p-sortIcon field="user.name" /></th>
                        <th pSortableColumn="allowRead">Lectura <p-sortIcon field="allowRead" /></th>
                        <th pSortableColumn="allowWrite">Escritura <p-sortIcon field="allowWrite" /></th>
                        <th [width]="150"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-userPermission let-columns="columns">
                    <tr (dblclick)="editUserGroupPermission('USER', userPermission)">
                        <td>{{userPermission.user?.name}}</td>
                        <td>
                          <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': userPermission.allowRead, 'text-red-500 pi-times-circle': !userPermission.allowRead }"></i>
                        </td> 
                        <td>
                          <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': userPermission.allowWrite, 'text-red-500 pi-times-circle': !userPermission.allowWrite }"></i>
                        </td> 
                        <td>
                            <div class="flex gap-2 justify-content-end">
                                <p-button (click)="deleteUserGroup(userPermission)"
                                    [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                <p-button (click)="editUserGroupPermission('USER', userPermission)" [rounded]="true"
                                    [text]="false"><i class="pi pi-pencil"></i></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                    <td [attr.colspan]="4">        
                       No se han encontrado usuarios
                    </td>
                  </tr>
                </ng-template>
            </p-table>
        </p-tabPanel>
        <p-tabPanel header="Grupos">
          <div class="flex justify-content-end">
            <p-button label="Añadir grupo"  icon="pi pi-plus" styleClass=""
                (click)="editUserGroupPermission('GROUP', null)"></p-button>
          </div>

          <p-table styleClass="m-1 mt-4" #grid [value]="groupsPermissions" [loading]="loading" [paginator]="false"
               [scrollable]="true" scrollHeight="flex"
              paginatorDropdownAppendTo="body">
              <ng-template pTemplate="header" let-columns>
                  <tr>
                      <th pSortableColumn="group.name">Grupo <p-sortIcon field="group.name" /></th>
                      <th pSortableColumn="allowRead">Lectura <p-sortIcon field="alloRead" /></th>
                      <th pSortableColumn="allowWrite">Escritura <p-sortIcon field="allowWrite" /></th>
                      <th [width]="150"></th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-groupPermission let-columns="columns">
                  <tr (dblclick)="editUserGroupPermission('GROUP', groupPermission)">
                      <td>{{groupPermission.group?.name}}</td>
                      <td>
                        <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': groupPermission.allowRead, 'text-red-500 pi-times-circle': !groupPermission.allowRead }"></i>
                      </td> 
                      <td>
                        <i class="pi" [ngClass]="{ 'text-green-500 pi-check-circle': groupPermission.allowWrite, 'text-red-500 pi-times-circle': !groupPermission.allowWrite }"></i>
                      </td> 
                      <td>
                          <div class="flex gap-2 justify-content-end">
                              <p-button  (click)="deleteUserGroup(groupPermission)"
                                  [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                              <p-button  (click)="editUserGroupPermission('GROUP', groupPermission)" [rounded]="true"
                                  [text]="false"><i class="pi pi-pencil"></i></p-button>
                          </div>
                      </td>
                  </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="4">        
                     No se han encontrado grupos
                  </td>
                </tr>
              </ng-template>
          </p-table>
      </p-tabPanel>